import React, { createContext, useReducer, useContext } from "react";
import { Dispatch, State, EditorAnglesProps } from "./types";
import editorAnglesReducer from "./reducer";


const EditorAnglesStateContext = createContext<State | undefined>(undefined);
const EditorAnglesDispatchContext = createContext<Dispatch | undefined>(undefined);

const EditorAnglesProvider = ({ children }: EditorAnglesProps) => {
    const [state, dispatch] = useReducer(editorAnglesReducer, {
        angles: [],
        selectedAngles: [],
        dropdownAngles: [],
        anglesInitialised: false,
        anglesAudio: [],
        audioPlayerReady: false,
    });
    return (
        <EditorAnglesStateContext.Provider value={state}>
            <EditorAnglesDispatchContext.Provider value={dispatch}>
                {children}
            </EditorAnglesDispatchContext.Provider>
        </EditorAnglesStateContext.Provider>
    );
};

const useEditorAnglesState = () => {
    const context = useContext(EditorAnglesStateContext);
    if (context === undefined) {
        throw new Error("useEditorAnglesState must be used within a EditorAnglesProvider");
    }
    return context;
};

const useEditorAnglesDispatch = () => {
    const context = useContext(EditorAnglesDispatchContext);
    if (context === undefined) {
        throw new Error("useEditorAnglesDispatch must be used within a EditorAnglesProvider");
    }
    return context;
};

export { EditorAnglesProvider, useEditorAnglesState, useEditorAnglesDispatch };